import { useTranslation } from 'react-i18next'
import { useNavigation } from '@/context/NavigationContext'
import type { Page } from '@/context/NavigationContext'

interface MenuItem {
  path: Page
  label: string
  icon: string
}

const menuItems: readonly MenuItem[] = [
  { path: '/', label: 'sidebar.dashboard', icon: '📊' },
  { path: '/habit', label: 'sidebar.habit', icon: '✅' },
  { path: '/weekly', label: 'sidebar.weekly', icon: '📅' },
  { path: '/tasks', label: 'sidebar.tasks', icon: '📝' },
  { path: '/finance', label: 'sidebar.finance', icon: '💰' },
  { path: '/settings', label: 'sidebar.settings', icon: '⚙️' },
]

export default function Sidebar(): JSX.Element {
  const { t } = useTranslation()
  const { currentPage, navigate } = useNavigation()

  return (
    <aside className="w-64 bg-white dark:bg-slate-800 shadow-lg p-4 h-full overflow-y-auto flex flex-col">
      <nav className="space-y-2 flex-1">
        {menuItems.map((item) => {
          const isActive = currentPage === item.path
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition text-left text-sm font-semibold whitespace-nowrap overflow-hidden text-ellipsis ${
                isActive
                  ? 'bg-blue-100 dark:bg-blue-900 text-blue-900 dark:text-blue-100 font-bold'
                  : 'text-gray-700 dark:text-white hover:bg-gray-100 dark:hover:bg-slate-700 font-semibold'
              }`}
              aria-current={isActive ? 'page' : undefined}
            >
              <span className="text-xl flex-shrink-0">{item.icon}</span>
              <span className="truncate">{t(item.label)}</span>
            </button>
          )
        })}
      </nav>
      
      {/* Footer */}
      <div className="border-t border-gray-200 dark:border-slate-700 pt-4 mt-4 text-center">
        <p className="text-xs text-gray-600 dark:text-gray-400 space-x-1">
          <span>Made with</span>
          <span className="text-red-500 text-sm">❤️</span>
          <span>by</span>
          <a
            href="https://sadatpour.ir"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 dark:text-blue-400 hover:underline font-medium"
          >
            Mojtaba Sadatpour
          </a>
        </p>
      </div>
    </aside>
  )
}
